import { Image, View } from '@react-pdf/renderer';
import { FunctionComponent } from 'react';
import logo from '../../assets/pdf/firedos-logo-500-95.png';

const PdfHeader: FunctionComponent<{ height: number }> = ({ height }) => (
  <View
    fixed={true}
    style={{
      width: '100%',
      height,
      backgroundColor: '#283237',
      position: 'absolute',
      top: 0,
    }}
  >
    <Image
      src={logo}
      style={{
        width: 112,
        height: 21,
        position: 'absolute',
        bottom: 27,
        right: 30,
      }}
    />
  </View>
);

export default PdfHeader;
